module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "lavContainer",
    style: (_vm.style)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62c9b093"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-lottie/src/lottie.vue
// module id = 1392
// module chunks = 0